const enCommon = {
  // Admin Common
  "admin.common.delete": "Delete",
  "admin.common.edit": "Edit",
  "admin.common.add": "Add",
  "admin.common.save": "Save",
  "admin.common.cancel": "Cancel",
  "admin.common.confirm": "Confirm",
  "admin.common.loading": "Loading...",
  "admin.common.saving": "Saving...",
  "admin.common.sending": "Sending...",
  "admin.common.search": "Search",
  "admin.common.reset": "Reset",
  "admin.common.success": "Operation successful",
  "admin.common.error": "Operation failed",
  "admin.common.confirmDelete": "Are you sure you want to delete?",
  "admin.common.batchDelete": "Batch Delete",
  "admin.common.batchApprove": "Batch Approve",
  "admin.common.batchReject": "Batch Reject",

  // Admin Alert
  "admin.alert.success": "Success",
  "admin.alert.error": "Error",
  "admin.alert.warning": "Warning",
  "admin.alert.info": "Information",
  "admin.alert.successMessage": "Your operation has been completed successfully!",
  "admin.alert.errorMessage": "An error occurred, please try again later.",
  "admin.alert.warningMessage": "This action cannot be undone, please proceed with caution.",
  "admin.alert.infoMessage": "This is an informational message.",
  "admin.alert.confirm": "Confirm Delete",
  "admin.alert.confirmMessage": "Are you sure you want to delete this record? This action cannot be undone.",
  "admin.alert.autoCloseMessage": "This message will automatically close in 3 seconds",
  "admin.alert.toastSuccess": "Saved successfully!",
  "admin.alert.toastError": "Failed to save, please try again",

  // Navbar
  "nav.about": "About Us",
  "nav.partners": "Partners",
  "nav.events": "Events",
  "nav.guests": "Guests",
  "nav.contact": "Contact",
  "nav.siteName": "Global Tech Roundtable Alliance",
  "nav.siteNameShort": "GTRA",

  // Hero
  "hero.badge": "Global Tech Innovation Exchange Platform",
  "hero.title": "Connecting Global",
  "hero.titleHighlight": "Innovation Forces",
  "hero.subtitle": "The Global Tech Roundtable Alliance (GTRA) brings together top scholars, scientists, and innovative enterprises to build an international network of scientific and technological cooperation, transcending borders to advance human technological civilization.",
  "hero.cta.learn": "Learn More",
  "hero.cta.events": "Explore Events",
  "hero.cta.apply": "Apply for Partnership",
  "hero.stat1.number": "30+",
  "hero.stat1.label": "Countries",
  "hero.stat2.number": "150+",
  "hero.stat2.label": "Partner Institutions",
  "hero.stat3.number": "50+",
  "hero.stat3.label": "Annual Events",

  // About Summary
  "about.badge": "About GTRA",
  "about.title": "Mission & Vision",
  "about.description": "Founded in 2020, the Global Tech Roundtable Alliance (GTRA) is an international organization dedicated to promoting cross-border scientific and technological innovation exchange and cooperation. We bring together top universities, research institutions, innovative enterprises, and policy organizations to build bridges connecting global innovation ecosystems.",
  "about.stat1.number": "30+",
  "about.stat1.label": "Countries",
  "about.stat2.number": "150+",
  "about.stat2.label": "Partner Institutions",
  "about.stat3.number": "50+",
  "about.stat3.label": "Annual Events",
  "about.stat4.number": "5000+",
  "about.stat4.label": "Expert Participants",
  "about.learnMore": "Learn About GTRA",

  // Partners Section (Home)
  "partners.home.badge": "Global Partners",
  "partners.home.title": "Building Innovation Ecosystems Together",
  "partners.home.subtitle": "Uniting world-class universities, research institutions, and innovative enterprises to drive technological progress",
  "partners.home.viewAll": "View All Partners",

  // Events Section (Home)
  "events.home.badge": "Events",
  "events.home.title": "Upcoming Events",
  "events.home.subtitle": "Explore upcoming global tech innovation exchange events and meet world-leading innovators",
  "events.home.viewAll": "View All Events",
  "events.home.register": "Register Now",

  // Guests Section (Home)
  "guests.home.badge": "Featured Guests",
  "guests.home.title": "Distinguished Speakers",
  "guests.home.subtitle": "World-class scholars, scientists, and innovation leaders sharing visions for the technological future",
  "guests.home.viewProfile": "View Profile",
  "guests.home.viewAll": "View All Guests",

  // Event Types
  "event.type.offline": "In-Person",
  "event.type.online": "Online",
  "event.type.hybrid": "Hybrid",

  // Partners Page
  "partnersPage.hero.title": "Global Partners",
  "partnersPage.hero.subtitle": "Partnering with world-leading institutions to drive scientific innovation and human progress",
  "partnersPage.grid": "Grid",
  "partnersPage.list": "List",
  "partnersPage.filter.type": "By Type",
  "partnersPage.filter.region": "By Region",
  "partnersPage.type.all": "All",
  "partnersPage.type.university": "University",
  "partnersPage.type.research": "Research Inst.",
  "partnersPage.type.enterprise": "Enterprise",
  "partnersPage.type.nonprofit": "Non-profit",
  "partnersPage.region.all": "All Regions",
  "partnersPage.region.asia": "Asia",
  "partnersPage.region.europe": "Europe",
  "partnersPage.region.americas": "Americas",
  "partnersPage.region.africa": "Africa & Middle East",
  "partnersPage.region.oceania": "Oceania",
  "partnersPage.collab": "Collaboration Areas",
  "partnersPage.visitWebsite": "Visit Website",
  "partnersPage.donors.badge": "Thank You",
  "partnersPage.donors.title": "Donors & Supporters",
  "partnersPage.donors.subtitle": "Heartfelt thanks to our generous global supporters who fuel the advancement of innovation",

  // Events Page
  "eventsPage.hero.title": "Global Events",
  "eventsPage.hero.subtitle": "Explore global tech innovation exchange events, connecting the most cutting-edge ideas and practices",
  "eventsPage.upcoming": "Upcoming",
  "eventsPage.past": "Past Events",
  "eventsPage.viewPast": "View Details",
  "eventsPage.filter.type": "Event Type",
  "eventGallery.title": "Event Gallery",
  "eventGallery.photos": "photos",
  "eventGallery.photo": "photo",
  "eventsPage.filter.month": "Month",
  "eventsPage.filter.region": "Region",
  "eventsPage.filter.all": "All",
  "eventsPage.noEvents": "No events found matching your criteria",
  "eventsPage.register": "Register Now",
  "eventsPage.learnMore": "Learn More",
  "eventsPage.plan.badge": "Future Plans",
  "eventsPage.plan.title": "Event Roadmap",
  "eventsPage.plan.subtitle": "Looking ahead, continuously expanding our global innovation exchange footprint",

  // Footer
  "footer.description": "Global Tech Roundtable Alliance (GTRA) — Connecting global innovation forces, building the technological future together through high-level forums, roundtable dialogues, and international collaboration.",
  "footer.quickLinks": "Quick Links",
  "footer.contactUs": "Contact Us",
  "footer.subscribe.title": "Stay Informed",
  "footer.subscribe.desc": "Get the latest GTRA events, research updates, and partnership opportunities",
  "footer.subscribe.placeholder": "Enter your email address",
  "footer.subscribe.btn": "Subscribe",
  "footer.subscribe.success": "Subscribed successfully, thank you!",
  "footer.copyright": "© 2026 Global Tech Roundtable Alliance (GTRA). All rights reserved.",
  "footer.address": "Melenhorst 5, Losser",
  "footer.email": "info@gtraweb3.com",
  "footer.phone": "+1 2672435802",

  // Common
  "common.readMore": "Read More",
  "common.viewAll": "View All",
  "common.close": "Close",
  "common.loading": "Loading...",
  "common.lang.zh": "中文",
  "common.lang.en": "EN",

  // Donate
  "nav.donate": "Support Us",

  // Event Modal
  "eventModal.tab.overview": "Overview",
  "eventModal.tab.agenda": "Agenda",
  "eventModal.tab.speakers": "Speakers",
  "eventModal.tab.register": "Register",
  "eventModal.agenda.type.keynote": "Keynote",
  "eventModal.agenda.type.panel": "Panel",
  "eventModal.agenda.type.workshop": "Workshop",
  "eventModal.agenda.type.break": "Break",
  "eventModal.agenda.type.ceremony": "Ceremony",
  "eventModal.register.name": "Full Name",
  "eventModal.register.email": "Email",
  "eventModal.register.org": "Institution / Organization",
  "eventModal.register.phone": "Phone Number",
  "eventModal.register.type": "Participation Mode",
  "eventModal.register.type.offline": "In-Person",
  "eventModal.register.type.online": "Online",
  "eventModal.register.message": "Additional Notes (Optional)",
  "eventModal.register.submit": "Submit Registration",
  "eventModal.register.success": "Registration successful! We will contact you to confirm shortly.",
  "eventModal.register.ph.name": "Enter your full name",
  "eventModal.register.ph.email": "Enter your email address",
  "eventModal.register.ph.org": "Enter your institution or organization",
  "eventModal.register.ph.phone": "Enter your phone number",
  "eventModal.register.ph.message": "Any other notes or requests (max 500 characters)",

  // Guests Page
  "guestsPage.hero.badge": "Distinguished Guests",
  "guestsPage.hero.title": "Featured Guests",
  "guestsPage.hero.subtitle": "World-class scholars, scientists, and innovation leaders sharing visions for the technological future",
  "guestsPage.filter.year": "By Year",
  "guestsPage.filter.expertise": "By Field",
  "guestsPage.filter.country": "By Country",
  "guestsPage.filter.all": "All",
  "guestsPage.year.all": "All Years",
  "guestsPage.count": "Guests",
  "guestsPage.viewProfile": "View Profile",
  "guestsPage.modal.bio": "Biography",
  "guestsPage.modal.expertise": "Research Areas",
  "guestsPage.modal.awards": "Awards & Honors",
  "guestsPage.modal.publications": "Publications",
  "guestsPage.modal.pubCount": " papers",
  "guestsPage.modal.close": "Close",
  "guestsPage.modal.events": "Events Participated",
  "guestsPage.modal.events.role": "Role",
  "guestsPage.modal.events.empty": "No event records available",

  // Partners Detail Modal
  "partnerModal.detail": "Institution Details",
  "partnerModal.collab": "Collaboration Focus",
  "partnerModal.projects": "Joint Projects",
  "partnerModal.stats.years": "Years Together",
  "partnerModal.stats.projects": "Joint Projects",
  "partnerModal.stats.experts": "Experts Involved",
  "partnerModal.viewSite": "Visit Website",
  "partnerModal.close": "Close",

  // Partnership Apply Form
  "partnersPage.apply.badge": "Join Us",
  "partnersPage.apply.title": "Apply for Partnership",
  "partnersPage.apply.subtitle": "Fill in the partnership interest form and we will contact you within 3 business days",
  "partnersPage.apply.form.orgName": "Institution Name *",
  "partnersPage.apply.form.orgType": "Institution Type *",
  "partnersPage.apply.form.orgType.university": "University / Academic",
  "partnersPage.apply.form.orgType.research": "Research Institute",
  "partnersPage.apply.form.orgType.enterprise": "Enterprise / Startup",
  "partnersPage.apply.form.orgType.nonprofit": "Non-profit Organization",
  "partnersPage.apply.form.orgType.government": "Government / Public",
  "partnersPage.apply.form.contactName": "Contact Name *",
  "partnersPage.apply.form.contactTitle": "Contact Title",
  "partnersPage.apply.form.email": "Contact Email *",
  "partnersPage.apply.form.phone": "Phone Number",
  "partnersPage.apply.form.country": "Country / Region *",
  "partnersPage.apply.form.domain": "Proposed Collaboration Area *",
  "partnersPage.apply.form.domain.ai": "AI & Machine Learning",
  "partnersPage.apply.form.domain.quantum": "Quantum Computing",
  "partnersPage.apply.form.domain.biotech": "Biotechnology & Health",
  "partnersPage.apply.form.domain.climate": "Climate & Sustainability",
  "partnersPage.apply.form.domain.energy": "Clean Energy",
  "partnersPage.apply.form.domain.space": "Aerospace",
  "partnersPage.apply.form.domain.other": "Other Fields",
  "partnersPage.apply.form.intention": "Partnership Intent *",
  "partnersPage.apply.form.submit": "Submit Application",
  "partnersPage.apply.form.success": "Application submitted! We will reach out within 3 business days.",
  "partnersPage.apply.form.ph.orgName": "Enter full institution name",
  "partnersPage.apply.form.ph.contactName": "Enter contact person name",
  "partnersPage.apply.form.ph.contactTitle": "Enter contact person title",
  "partnersPage.apply.form.ph.email": "Enter contact email",
  "partnersPage.apply.form.ph.phone": "Enter phone number (optional)",
  "partnersPage.apply.form.ph.country": "Enter country or region",
  "partnersPage.apply.form.ph.intention": "Briefly describe your partnership interests, proposed collaboration formats, and expected outcomes (max 500 characters)",
  "partnersPage.apply.perks.title": "Join the GTRA Network",
  "partnersPage.apply.perks.p1.title": "Global Network Access",
  "partnersPage.apply.perks.p1.desc": "Directly connect with 150+ leading institutions across 30+ countries",
  "partnersPage.apply.perks.p2.title": "Premium Event Access",
  "partnersPage.apply.perks.p2.desc": "Priority participation in annual summits, roundtables, and specialized workshops",
  "partnersPage.apply.perks.p3.title": "Joint Research Opportunities",
  "partnersPage.apply.perks.p3.desc": "Participate in cross-institutional, interdisciplinary frontier research collaborations",
  "partnersPage.apply.perks.p4.title": "Enhanced Brand Visibility",
  "partnersPage.apply.perks.p4.desc": "Greater institutional recognition and influence within the global innovation community",

  // Media Coverage
  "media.badge": "Media Coverage",
  "media.title": "In the Global Spotlight",
  "media.subtitle": "GTRA's work and innovations have attracted widespread coverage and in-depth reporting from the world's leading media outlets and academic publications",
  "media.readMore": "Read More",

  // About Page Reports
  "aboutPage.reports.badge": "Knowledge Hub",
  "aboutPage.reports.title": "Annual Reports & White Papers",
  "aboutPage.reports.subtitle": "GTRA publishes annual reports, white papers, and policy briefs to systematically document global tech innovation ecosystem progress, serving as authoritative references for policymakers, researchers, and innovators",

  // Guests Modal Similar
  "guestsPage.modal.similar": "You May Also Know",
  "aboutPage.hero.badge": "About Us",
  "aboutPage.hero.title": "About the Global Tech Roundtable Alliance",
  "aboutPage.hero.subtitle": "Connecting global innovation forces, advancing human technological progress, building an open and inclusive innovation ecosystem",
  "aboutPage.mission.badge": "Mission & Vision",
  "aboutPage.mission.title": "Our Mission",
  "aboutPage.mission.desc1": "Founded in 2020, the Global Tech Roundtable Alliance (GTRA) is an international non-profit organization dedicated to promoting cross-border scientific and technological innovation exchange and cooperation. We believe that open tech innovation exchange is one of the most important driving forces for human civilizational progress.",
  "aboutPage.mission.desc2": "By bringing together top universities, research institutions, innovative enterprises, and government agencies from 30+ countries, GTRA builds bridges connecting global innovation ecosystems and creates the highest-caliber international dialogue platform in the field of technological innovation.",
  "aboutPage.mission.v1.title": "Open & Inclusive",
  "aboutPage.mission.v1.desc": "Welcoming innovators from diverse backgrounds and fields to join and share knowledge and wisdom",
  "aboutPage.mission.v2.title": "Collaborative & Win-Win",
  "aboutPage.mission.v2.desc": "Promoting deep cross-institutional, interdisciplinary, and cross-border collaboration to address humanity's major challenges",
  "aboutPage.mission.v3.title": "Truth-Seeking & Innovative",
  "aboutPage.mission.v3.desc": "Upholding the scientific spirit, encouraging breakthrough thinking, and advancing the exploration and application of frontier technologies",
  "aboutPage.timeline.badge": "Our Journey",
  "aboutPage.timeline.title": "GTRA Milestones",
  "aboutPage.team.badge": "Core Team",
  "aboutPage.team.title": "Our Team",
  "aboutPage.team.subtitle": "Professionals from world-leading institutions, united in advancing GTRA's mission and vision",
  "aboutPage.team.executive": "Executive Team",
  "aboutPage.team.advisory": "Advisory Board",
  "aboutPage.contact.badge": "Contact",
  "aboutPage.contact.title": "Get in Touch",
  "aboutPage.contact.subtitle": "Whether for partnership inquiries, media contacts, or general questions, we look forward to hearing from you",
  "aboutPage.contact.form.name": "Full Name *",
  "aboutPage.contact.form.email": "Email *",
  "aboutPage.contact.form.subject": "Subject",
  "aboutPage.contact.form.message": "Message *",
  "aboutPage.contact.form.submit": "Send Message",
  "aboutPage.contact.form.success": "Thank you for your message! We will reply within 2 business days.",
  "aboutPage.contact.form.ph.name": "Enter your full name",
  "aboutPage.contact.form.ph.email": "Enter your email address",
  "aboutPage.contact.form.ph.subject": "Enter the subject of your inquiry",
  "aboutPage.contact.form.ph.message": "Enter your message (max 500 characters)",

  // Admin Email Config
  "admin.emailConfig.title": "Email Configuration",
  "admin.emailConfig.description": "Configure SMTP settings for contact form emails",
  "admin.emailConfig.add": "Add Configuration",
  "admin.emailConfig.addConfig": "Add Configuration",
  "admin.emailConfig.editConfig": "Edit Configuration",
  "admin.emailConfig.noConfigs": "No email configurations found",
  "admin.emailConfig.active": "Active",
  "admin.emailConfig.from": "From",
  "admin.emailConfig.to": "To",
  "admin.emailConfig.setActive": "Set Active",
  "admin.emailConfig.edit": "Edit",
  "admin.emailConfig.delete": "Delete",
  "admin.emailConfig.smtpHost": "SMTP Host",
  "admin.emailConfig.smtpPort": "SMTP Port",
  "admin.emailConfig.smtpUser": "SMTP Username",
  "admin.emailConfig.smtpPass": "SMTP Password",
  "admin.emailConfig.fromEmail": "From Email",
  "admin.emailConfig.fromName": "From Name",
  "admin.emailConfig.toEmail": "To Email",
  "admin.emailConfig.setAsActive": "Set as active configuration",
  "admin.emailConfig.cancel": "Cancel",
  "admin.emailConfig.save": "Save",

  // Admin Subscriptions
  "admin.subscriptions.title": "Subscription Management",
  "admin.subscriptions.description": "Manage newsletter subscribers",
  "admin.subscriptions.total": "Total Subscribers",
  "admin.subscriptions.active": "Active Subscribers",
  "admin.subscriptions.unsubscribed": "Unsubscribed",
  "admin.subscriptions.filterAll": "All",
  "admin.subscriptions.filterActive": "Active Only",
  "admin.subscriptions.filterUnsubscribed": "Unsubscribed Only",
  "admin.subscriptions.searchPlaceholder": "Search by email...",
  "admin.subscriptions.email": "Email",
  "admin.subscriptions.status": "Status",
  "admin.subscriptions.source": "Source",
  "admin.subscriptions.subscribedAt": "Subscribed At",
  "admin.subscriptions.unsubscribedAt": "Unsubscribed At",
  "admin.subscriptions.actions": "Actions",
  "admin.subscriptions.statusActive": "Active",
  "admin.subscriptions.statusUnsubscribed": "Unsubscribed",
  "admin.subscriptions.noData": "No subscription data",
  "admin.subscriptions.confirmDelete": "Are you sure you want to delete this subscription?",
  "admin.subscriptions.deleteSuccess": "Deleted successfully",
  "admin.subscriptions.deleteFailed": "Deletion failed",
  "admin.subscriptions.sendNewsletter": "Send Newsletter",
  "admin.subscriptions.emailSubject": "Email Subject",
  "admin.subscriptions.emailContent": "Email Content",
  "admin.subscriptions.subjectPlaceholder": "Enter email subject...",
  "admin.subscriptions.contentPlaceholder": "Enter email content (HTML supported)...",
  "admin.subscriptions.recipientInfo": "Will be sent to {{count}} active subscribers",
  "admin.subscriptions.fillAllFields": "Please fill in all fields",
  "admin.subscriptions.emailQueued": "Email sending task started",
  "admin.subscriptions.sendFailed": "Failed to send",
  "admin.subscriptions.send": "Send",
  "admin.subscriptions.send": "Send",
  "admin.subscriptions.tabSubscriptions": "Subscriptions",
  "admin.subscriptions.tabHistory": "Send History",
  "admin.subscriptions.historyNoData": "No sending records",
  "admin.subscriptions.historySubject": "Email Subject",
  "admin.subscriptions.historyRecipientCount": "Result",
  "admin.subscriptions.historyStatus": "Status",
  "admin.subscriptions.historyCreatedBy": "Sent By",
  "admin.subscriptions.historyCreatedAt": "Sent At",
  "admin.subscriptions.historyStatus_completed": "Completed",
  "admin.subscriptions.historyStatus_sending": "Sending",
  "admin.subscriptions.historyStatus_failed": "Failed",
  "admin.subscriptions.historyStatus_completed_with_errors": "Partial Success",
  "admin.common.pageInfo": "Page {{page}} of {{total}}",
  "admin.common.prevPage": "Previous",
  "admin.common.nextPage": "Next",
  "admin.common.sending": "Sending...",

  // Not Found Page
  "notFound.title": "Page Not Found",
  "notFound.description": "Sorry, the page you're looking for may have been removed or the address is incorrect",
  "notFound.goHome": "Back to Home",
  "notFound.goBack": "Go Back",
  "notFound.viewEvents": "View Events",
  "notFound.quickLinks": "Quick Links",
  "notFound.help": "If you think this is an error, please",
  "notFound.contactUs": "contact us",
  "nav.home": "Home",

  // Team Member Modal
  "teamPage.modal.biography": "Biography",
  "teamPage.modal.viewLinkedIn": "View LinkedIn Profile",
  "teamPage.modal.close": "Close",
};

export default enCommon;
